import styled from "styled-components";

export const RceStageElement = styled.div.attrs<{
  elementRef?: string;
  "data-id"?: string;
}>((props) => ({
  "data-id": props.elementRef,
}))<{
  elementsPadding?: { vertical?: number; horizontal?: number };
  isGrabbable?: boolean;
  isSelected?: boolean;
  displayHovered?: boolean;
  isMultiSelected?: boolean;
  hasCcOnStageElement?: boolean;
  elementRef?: string;
}>`
  position: relative;

  ${(props) =>
    props.elementsPadding
      ? `
    padding: ${props.elementsPadding.vertical || 0}px ${props.elementsPadding.horizontal || 0}px;
    --paddingX: ${props.elementsPadding?.horizontal ?? 10};
    --paddingY: ${props.elementsPadding?.vertical ?? 10};
  `
      : ""}

  ${(props) =>
    props.isMultiSelected
      ? `
    z-index: 0;
  `
      : ""}

  ${(props) =>
    props.isGrabbable
      ? `
    cursor: grab;
  `
      : ""}

  ${(props) =>
    props.displayHovered
      ? `
    box-shadow: inset 0px 0px 0px 1px rgba(33,150,243,0.2);
  `
      : ""}

  ${(props) =>
    props.isSelected
      ? `
    box-shadow: inset 0px 0px 0px 1px rgba(33,150,243,0.8);
  `
      : ""}

  ${(props) =>
    props.hasCcOnStageElement &&
    `
    border: 2px dashed rgb(0 128 0 / 30%);
  `}
`;

export const ConstrainedHeight = styled.div<{
  height?: number | string;
}>`
  --height: ${(props) =>
    typeof props?.height === "number" ? `${props.height}px` : props?.height || "auto"};
  height: var(--height);
`;

export const ParallaxWrapper = styled.div.attrs({ role: "presentation" })`
  position: relative;
`;
